import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "key-value" }
const _hoisted_2 = { class: "heading" }
const _hoisted_3 = { class: "title text-deemphasized" }
const _hoisted_4 = { class: "count" }
const _hoisted_5 = {
  key: 0,
  class: "empty mmt-2 text-deemphasized"
}
const _hoisted_6 = { class: "no-rows" }
const _hoisted_7 = { class: "show-configuration mmt-1" }
const _hoisted_8 = ["data-testid"]
const _hoisted_9 = ["data-testid"]


import { computed, toRefs } from 'vue';
import KeyValueRow from '@shell/components/Resource/Detail/Metadata/KeyValueRow.vue';
import { useStore } from 'vuex';
import { useI18n } from '@shell/composables/useI18n';
import { Type } from '@components/Pill/types';

export type KeyValueType = {[key: string]: string};

export interface Row {
    key: string;
    value: string;
}

export interface KeyValueProps {
    propertyName: string;
    rows: Row[];
    type: Type;

    maxRows?: number;
    onShowConfiguration?: (returnFocusSelector: string) => void;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'KeyValue',
  props: {
    propertyName: {},
    rows: {},
    type: {},
    maxRows: { default: 4 },
    onShowConfiguration: { type: Function, default: undefined }
  },
  emits: ['show-configuration'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const { propertyName, rows, maxRows } = toRefs(props);

const store = useStore();
const i18n = useI18n(store);
const emit = __emit;

// Account for the show all button
const visibleRowsLength = computed(() => (rows.value.length > maxRows.value ? maxRows.value - 1 : rows.value.length));
const visibleRows = computed(() => rows.value.slice(0, visibleRowsLength.value));
const lowercasePropertyName = computed(() => propertyName.value.toLowerCase());

const showShowAllButton = computed(() => rows.value.length > maxRows.value);
const showAllLabel = computed(() => `Show all ${ lowercasePropertyName.value }`);

const displayValue = (row: Row) => `${ row.key }: ${ row.value }`;
const showConfigurationEmptyDataTestId = computed(() => `empty-show-configuration_${ propertyName.value.replaceAll(' ', '').toLowerCase() }`);
const showConfigurationEmptyFocusSelector = computed(() => `[data-testid="${ showConfigurationEmptyDataTestId.value }"]`);
const showConfigurationMoreDataTestId = computed(() => `more-show-configuration_${ propertyName.value.replaceAll(' ', '').toLowerCase() }`);
const showConfigurationMoreFocusSelector = computed(() => `[data-testid="${ showConfigurationMoreDataTestId.value }"]`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(propertyName)), 1),
      _cache[2] || (_cache[2] = _createTextVNode()),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(rows).length), 1)
    ]),
    _cache[4] || (_cache[4] = _createTextVNode()),
    (visibleRows.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(i18n).t('component.resource.detail.metadata.keyValue.noRows', {propertyName: lowercasePropertyName.value})), 1),
          _cache[3] || (_cache[3] = _createTextVNode()),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              "data-testid": showConfigurationEmptyDataTestId.value,
              class: "secondary text-deemphasized",
              href: "#",
              onClick: _cache[0] || (_cache[0] = (ev) => {ev.preventDefault(); emit('show-configuration', showConfigurationEmptyFocusSelector.value);})
            }, _toDisplayString(_unref(i18n).t('component.resource.detail.metadata.keyValue.showConfiguration')), 9, _hoisted_8)
          ])
        ]))
      : _createCommentVNode("", true),
    _cache[5] || (_cache[5] = _createTextVNode()),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleRows.value, (row) => {
      return (_openBlock(), _createElementBlock("div", {
        key: displayValue(row),
        class: "key-value-entry"
      }, [
        _createVNode(KeyValueRow, {
          class: "rectangle",
          type: props.type,
          row: row
        }, null, 8, ["type", "row"])
      ]))
    }), 128)),
    _cache[6] || (_cache[6] = _createTextVNode()),
    (showShowAllButton.value)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          "data-testid": showConfigurationMoreDataTestId.value,
          href: "#",
          class: "show-all",
          onClick: _cache[1] || (_cache[1] = (ev) => {ev.preventDefault(); emit('show-configuration', showConfigurationMoreFocusSelector.value);})
        }, _toDisplayString(showAllLabel.value), 9, _hoisted_9))
      : _createCommentVNode("", true)
  ]))
}
}

})